const getKey = (key: string, userId?: string | null): string =>
    userId ? `user_${userId}_${key}` : key;

export const setLocalStorageItem = (key: string, value: string, userId?: string | null): void => {
    localStorage.setItem(getKey(key, userId), value);
};

export const getLocalStorageItem = (key: string, userId?: string | null): string | null =>
    localStorage.getItem(getKey(key, userId));

export const removeLocalStorageItem = (key: string, userId?: string | null): void => {
    localStorage.removeItem(getKey(key, userId));
};
